var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ov2024-list",class:{'ov2024-list--big' : _vm.isMapBig }},[_c('map-view',{attrs:{"base-path":_vm.basePath,"theme":_vm.theme,"mobile":false,"inactive":!!_vm.inactive,"election":_vm.election,"ep-base-path":_vm.epBasePath,"onkormanyzati-base-path":_vm.onkormanyzatiBasePath},on:{"map-size-changed":_vm.handleMapSizeChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }